module.exports = __webpack_public_path__ + "static/img/zhongduwumai.1416833c.png";